import React from 'react';
import { Checkbox, Col, Form, Row} from "antd";
import DG_Form from "../../../../../../custom/data-entry/form";
import DG_Cancel from "../../../../../../common/button/Cancel";
import DG_Button from "../../../../../../common/button/Button";
import DG_Submit from "../../../../../../common/button/Submit";

function ModalShiftWork(props) {
    const [form] = Form.useForm();

    const onFinish = (values) => {
        const shiftWorkIds = values.shiftWorkIds ? values.shiftWorkIds : [];
        const data = {
            ...props.dataShiftConfig,
            shiftWorkIds: shiftWorkIds
        }
        props.values(data)

    }

    return (
        <>
            <DG_Form form={form} mode={"add"} onFinish={onFinish}>

                <Form.Item name="shiftWorkIds">
                    <Checkbox.Group>
                        <Row className={"df__center-align"} gutter={24}>
                            {
                                props.data.map((item, key) => {
                                    return (

                                        <Col span={8}>
                                            <Checkbox
                                                name={"check"}
                                                key={key}
                                                value={item.shiftWorkId}

                                            >{item.title}
                                            </Checkbox>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Checkbox.Group>
                </Form.Item>

                <DG_Button >
                    <DG_Submit/>
                    <DG_Cancel/>
                </DG_Button>

            </DG_Form>
        </>
    );
}

export default ModalShiftWork;